//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid } from '@material-ui/core';
// import { useHistory } from 'react-router-dom';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
// import { PATH_DASHBOARD } from '../../system/constants';
// import { BASE_URL, DASHBOARD_ID_MY_SETTINGS, GO_TO_MY_SETTINGS, HERE, USER_TYPE_JS } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdTypography from '../../common/elemental/AfitdTypography';
// import AfitdButton from '../../common/elemental/AfitdButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: { marginTop: 50 },
    // goToMySettingsButton: { margin: 20, marginTop: 40, width: '47%', minWidth: 260, [theme.breakpoints.up('lg')]: { maxWidth: 450 } },
    title: { fontWeight: 'bold', fontSize: 26, marginTop: 40, marginBottom: 16 },
    message: { textAlign: 'center' },
    content: { textAlign: 'center' },
    // mainIcon: { fontSize: 93, color: 'rgba(216, 216, 216, 1)' },
    mainIcon: {
        color: theme.palette.secondary.main,
        fontSize: '100px',
    },
    // secondIcon: { background: 'rgba(29, 138, 139, 1)', color: '#fff', borderRadius: '50%', fontSize: 26, padding: 2, marginLeft: ' -30px', marginTop: '55px' },
    iconContainer: { display: 'flex', justifyContent: 'center' },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props,
        // handleClickGoToMySettingsButton,
    } = params;

    const defns = {
        root: { container: true, justify: 'center' },
        content: { item: true, xl: 10, lg: 10, md: 10, sm: 11, xs: 11 },
        title: { variant: 'h5', clsSkinnyBold: true /* clsLightBold: true */ },
        message: { variant: 'body1' },
        // goToMySettingsButton: {
        //     variant: 'contained',
        //     color: 'secondary',
        //     // label: isJs ? GO_TO_MY_DASHBOARD : GO_TO_MY_SETTINGS,
        //     label: GO_TO_MY_SETTINGS,
        //     onClick: handleClickGoToMySettingsButton,
        // },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const CancelSuccessfulMessage = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    // const appContext = useContext(AppContext);
    // const context = useContext(LayoutContext);

    // const { currentUser } = appContext;

    // const history = useHistory();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    // const handleClickGoToMySettingsButton = async () => {
    //     history.push(`${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}`);
    // };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        // handleClickGoToMySettingsButton
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.root}>
            <Grid {...defns.content}>
                <div {...defns.iconContainer}>
                    <CheckCircleIcon {...defns.mainIcon} />
                </div>
                <AfitdTypography {...defns.title}>Plan Canceled Successfully</AfitdTypography>
                <AfitdTypography {...defns.message}>Display message here (change me). Your refund will show up in the card statement within 14 days.</AfitdTypography>
                {/* <AfitdButton {...defns.goToMySettingsButton} /> */}
            </Grid>
        </Grid>
    );
};

export default CancelSuccessfulMessage;
